import type { ContextProfile } from '@/common/dataContext';

export type CompanyValuesSetupStatus = 'pending' | 'skipped' | 'completed';

export type CompanyValuesSetupState = {
  isFounder: boolean;
  status: CompanyValuesSetupStatus | null;
  shouldGate: boolean;
  shouldShowReminder: boolean;
};

/** Derive the founder-only setup state from the already hydrated login profile. */
export function resolveCompanyValuesSetupState(
  profile: ContextProfile | null | undefined,
  authenticatedEmployeeID?: string | number | null
): CompanyValuesSetupState {
  const selfOnboarding = profile?.companyInfo?.selfOnboarding;
  const currentEmployeeID =
    authenticatedEmployeeID ?? profile?.employeeInfo?.employeeID ?? profile?.employeeID;
  const isFounder =
    selfOnboarding?.status === 'active' &&
    selfOnboarding.founderEmployeeID != null &&
    String(currentEmployeeID) === String(selfOnboarding.founderEmployeeID);

  if (!isFounder) {
    return {
      isFounder: false,
      status: null,
      shouldGate: false,
      shouldShowReminder: false,
    };
  }

  const status = selfOnboarding.valuesSetupStatus ?? 'pending';
  return {
    isFounder: true,
    status,
    shouldGate: status === 'pending',
    shouldShowReminder: status === 'skipped',
  };
}

/** Settings and the setup itself remain reachable while pending. */
export function isCompanyValuesSetupAllowlistedPath(pathname: string): boolean {
  return pathname === '/setup/company-values' || pathname.startsWith('/settings');
}
